import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { afterItems, beforeItems } from '../data/comparison';
export function ComparisonSection() {
  return <section aria-labelledby="comparison-title" className="bg-white px-5 py-20 md:py-28" data-id="element-38" data-mp="39d6efn0ks9c8">
      <Reveal className="mx-auto max-w-content" data-id="element-39" data-mp="34ev6xixr6ax6">
        <h2 id="comparison-title" className="mx-auto max-w-3xl text-center text-3xl font-extrabold leading-[1.12] tracking-tight text-pine md:text-4xl" data-id="element-40" data-mp="2zglal50al49z">
          Every Session Improvised, or Every Session Already Planned.
        </h2>
        <div className="mt-12 grid items-start gap-6 md:grid-cols-2" data-id="element-41" data-mp="2qg59g270u98a">
          <ComparisonCard eyebrow="THE WAY IT FEELS RIGHT NOW" title="BEFORE" items={beforeItems} positive={false} data-id="element-42" data-mp="2lhtx9kt97mmw" />
          <ComparisonCard eyebrow="THE WAY IT COULD FEEL BY NEXT WEEK" title="WITH LACROSSE READY 360" items={afterItems} positive data-id="element-43" data-mp="joxefbt3rfs8" />
        </div>
        <div className="mt-12 flex justify-center" data-id="element-44" data-mp="3eh7rnbg5l87g">
          <CTAButton className="w-full max-w-md md:w-auto" data-id="element-45" data-mp="3ei0yecf43xpl" />
        </div>
      </Reveal>
    </section>;
}
interface ComparisonCardProps {
  eyebrow: string;
  title: string;
  items: string[];
  positive: boolean;
}
function ComparisonCard({
  eyebrow,
  title,
  items,
  positive
}: ComparisonCardProps) {
  const Icon = positive ? CheckIcon : XIcon;
  return <article className={`h-full rounded-card p-7 shadow-card md:p-8 ${positive ? 'bg-turquoise-tint' : 'bg-clay-tint'}`} data-id="element-46" data-mp="1zkp9ugacxaa">
      <p className={`text-[10px] font-bold uppercase tracking-[0.16em] ${positive ? 'text-turquoise' : 'text-clay'}`} data-id="element-47" data-mp="3jdop4w98syx7">
        {eyebrow}
      </p>
      <h3 className="mt-2 font-display text-xl font-extrabold tracking-tight text-pine md:text-2xl" data-id="element-48" data-mp="fxhjik79orls">{title}</h3>
      <ul className="mt-6 space-y-3" data-id="element-49" data-mp="krvlx6kcjyzy">
        {items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-50" data-mp="ukgdaltljy3o">
            <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-turquoise text-white' : 'bg-clay text-white'}`} data-id="element-51" data-mp="pmy20os3x6si">
              <Icon className="h-3 w-3" strokeWidth={3} aria-hidden="true" data-id="element-52" data-mp="gkyjfs1g1ung" />
            </span>
            <span className={`text-sm leading-snug ${positive ? 'font-medium text-ink' : 'text-slate-body'}`} data-id="element-53" data-mp="bnynwb280aal">
              {item}
            </span>
          </li>)}
      </ul>
    </article>;
}